import { Helpers } from '../../helpers';
import { IForecastRatioVolumeOuomType } from '../../interfaces/iforecast-ratio-volume-ouom-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastRatioVolumeOuomTypeBase {
  ForecastRatioVolumeOuomTypeId: number;
  Name: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;
  UpdatedBy: string;

  ForecastParameterDetails_ForecastRatioVolumeOuomType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastRatioVolumeOuomType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastRatioVolumeOuomType) {
    if (item) {

      this.ForecastRatioVolumeOuomTypeId = item.ForecastRatioVolumeOuomTypeId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastParameterDetails_ForecastRatioVolumeOuomType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastRatioVolumeOuomType);
      this.TypeCurveParameters_ForecastRatioVolumeOuomType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastRatioVolumeOuomType);
    }
  }
}